import type { FaireProductEntity } from "../../entity_types/product";

export const p_9hp5r692m8: FaireProductEntity = {
  token: "p_9hp5r692m8",
  type: "product",
  name: 'Meadow Fern 16" Adj. Necklace',
  brandToken: "b_5814217e",
  brandName: "Michael Michaud",
  imageUrl:
    "https://cdn.faire.com/fastly/c27218924b8c35ddd88b8f5e9461ee88c9798c829ddee73e9e6f5abb90506325.jpeg",
  galleryImageUrls: [],
  priceDollars: 79,
  description:
    'This Meadow Fern 16" Adjustable Necklace features a cast bronze pendant with a hand patina finish that highlights its botanical detail. Designed by Michael Michaud, the piece evokes authentic foliage textures and offers refined wearable art.',
  tags: [],
  msrpDollars: 198,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:49.568Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
